import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { AuthGuard } from './core/guard/auth.guard';
import { dashboardRoutes } from './features/dashboard/dashboard.routes';
import { bulkActivationRoutes } from './features/bulk-activation/bulk-activation.routes';
import { QrMainLayoutComponent } from './features/qr-main-layout/qr-main-layout.component';

const routes: Routes = [
  {
    path: '', component: QrMainLayoutComponent, canActivate: [AuthGuard], children: [
      dashboardRoutes,
      bulkActivationRoutes
    ]
  },
  { path: 'home', component: HomeComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
